/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function CheckBlackIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 14 12'
      {...props}
    >
      <path
        fill='#232B3A'
        stroke='#232B3A'
        strokeWidth={0.5}
        d='M4.596 8.906 1.47 5.78.404 6.836l4.192 4.193 9-9L12.54.97z'
      />
    </svg>
  )
}
